module.exports = __webpack_public_path__ + "img/casos-uso.9dcdec65.svg";